module.exports = __webpack_public_path__ + "static/media/dizz108.4e81de72.jpg";